import { config } from "core/config/app"

export const API_AI_CHEF_IMG = `${config.apiPrefix}/${config.apiVersion}/ai/img`
export const API_UPDATE_REQUEST_TYPE = `${config.apiPrefix}/${config.apiVersion}/recipe/request/:id/update`
// export const API_AI_CHEF_IMG = `/api/1.0.0/ai/img`
